import * as React from 'react';
import { withTranslation } from 'react-i18next';

declare global {
    interface Window { adsbygoogle: any; }
}


class Test extends React.Component<any, any>{
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    componentDidMount() {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    render() {

        return (
            <div className="i-body">
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <ins className="adsbygoogle"
                            style={{ display: "inline-block", width: "238px", height: "350px" }}
                            data-ad-client="ca-pub-3532000668144393"
                            data-ad-slot="7362637517">

                        </ins>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Test);